<template>
  <svg class="icon-spinner" width="24px"
       height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/spinner/blue</title>
    <g id="atoms/icons/24x24/spinner/blue" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M12,3.5 C16.6944204,3.5 20.5,7.30758688 20.5,12.0044833 C20.5,16.7013798 16.6944204,20.5 12,20.5 C7.30557963,20.5 8.44974788,18.860381 8.44974788,18.860381 C8.44974788,18.860381 8.73663115,18.4345836 9.34157328,18.5732328 C10.1631543,18.9084332 11.0602035,19.0915528 12,19.0915528 C15.912017,19.0915528 19.0833333,15.9185637 19.0833333,12.0044833 C19.0833333,8.09040295 15.912017,4.91741389 12,4.91741389 C8.08798302,4.91741389 4.91666667,8.09040295 4.91666667,12.0044833 C4.91666667,13.0394229 5.13838934,14.0225491 5.536901,14.9089045 L5.50646292,14.880827 C5.52773682,14.9107269 5.54755713,14.9399318 5.56599489,14.9684556 C5.61885358,15.087496 5.6771205,15.2051697 5.73850077,15.3209379 L5.74730792,15.3454522 C5.88193673,15.8075559 5.56625687,16.0019493 5.45064786,16.0561679 L5.41524653,16.0711942 C4.31993199,16.6704927 3.5,14.1668172 3.5,12.0044833 C3.5,7.30758688 7.30557963,3.5 12,3.5 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
